/* esm.sh - rxjs@7.8.1/dist/esm/internal/operators/filter */
import{operate as p}from"../util/lift.mjs";import{createOperatorSubscriber as c}from"./OperatorSubscriber.mjs";function a(t,o){return p((i,r)=>{let n=0;i.subscribe(c(r,e=>t.call(o,e,n++)&&r.next(e)))})}export{a as filter};
//# sourceMappingURL=filter.mjs.map